import { SerializedStyles, css } from '@emotion/react';
import { mediaQueries } from '../utils/css-utils';
import { ReactNode } from 'react';
import React from 'react';

type GridColProps = {
  colStart : number | string,
  colStartSm? : number | string,
  colStartMd? : number | string,
  colStartLg? : number | string,
  colStartXl? : number | string,
  colStartXxl? : number | string,
  colStartXxxl? : number | string,
  colEnd : number | string,
  colEndSm? : number | string,
  colEndMd? : number | string,
  colEndLg? : number | string,
  colEndXl? : number | string,
  colEndXxl? : number | string,
  colEndXxxl? : number | string,
  children : ReactNode,
  css?: SerializedStyles | SerializedStyles[]
}

const GridCol : React.FC<GridColProps> = ({ 
  colStart,
  colStartSm,
  colStartMd,
  colStartLg,
  colStartXl,
  colStartXxl,
  colStartXxxl,
  colEnd,
  colEndSm,
  colEndMd,
  colEndLg,
  colEndXl,
  colEndXxl,
  colEndXxxl,
  children,
  ...props
}) => {
 
  // Capitalize first letter of a string
  const capitalize = (s : string) => {
    return s.charAt(0).toUpperCase() + s.slice(1)
  }
  
  const colCss = [];
  const bps = [`sm`, `md`, `lg`, `xl`,`xxl`,`xxxl`];
  const colStartBase = colStart ?? 'auto';
  const colEndBase = colEnd ?? 'auto';
        
  // Styles for all columns
  colCss.push(css`
    grid-column-start: ${colStartBase};
    grid-column-end: ${colEndBase};
  `);
  
  // Looping over all the breakpoints 
  bps.forEach(bp => {
    const startVar = eval('colStart' + capitalize(bp));
    const endVar = eval('colEnd' + capitalize(bp));
    
    if (startVar) {
      colCss.push(css`
        ${mediaQueries[bp]} {
          grid-column-start: ${startVar};
        }
      `);
    }
    
    if (endVar) {
      colCss.push(css`
        ${mediaQueries[bp]} {
          grid-column-end: ${endVar};
        }
      `);
    }
  });
  
  return (
    <div {...props} css={colCss}>
      { children }
    </div>
  );
};

export default GridCol;